// extracted by mini-css-extract-plugin
export default {"container":"ResourceList__container___QBY6L","resourceContentContainer":"ResourceList__resourceContentContainer___VMfYJ","loadingContainer":"ResourceList__loadingContainer___Y2CSF"};